import React from 'react'
import Typography from 'APP/Converse/Typography'
import styled from 'styled-components/native'
import { useNavigation } from '@react-navigation/native'
import Button from 'APP/Converse/Button'

const Container = styled.View`
  margin: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

const TitleContainer = styled.View`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

const TitleTextContainer = styled.View`
  flex: 1;
`

type HeaderProps = {
  title: string
  description: string
  onClose?: () => void
}

export const Header = ({ title, description, onClose }: HeaderProps) => {
  const navigation = useNavigation()

  return (
    <Container>
      <TitleContainer>
        <TitleTextContainer>
          <Typography variant="h4" numberOfLines={1} ellipsizeMode="tail">
            {title}
          </Typography>
        </TitleTextContainer>
        <Button
          icon="close"
          variant="tertiary"
          iconVariant="materialIcons"
          widthVariant="icon"
          accessibilityLabel="Close Add Family Member Screen"
          onPress={onClose || navigation.goBack}
          testID="CLOSE_BTN"
        />
      </TitleContainer>
      <Typography variant="bodySmall">{description}</Typography>
    </Container>
  )
}
